import {
  Component,
  ElementRef,
  Inject,
  OnInit,
  ViewChild,
} from "@angular/core";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { AdminService } from "../admin.service";
import { Router } from "@angular/router";
import { MatSnackBar } from "@angular/material/snack-bar";

@Component({
  selector: "app-add-driver-route",
  templateUrl: "./add-driver-route.component.html",
  styleUrls: ["./add-driver-route.component.css"],
})
export class AddDriverRouteComponent implements OnInit {
  coordinatesForm!: FormGroup;
  pickupAutoComplete: any;
  pickupLat: any;
  pickupLong: any;
  dropLat: any;
  dropLong: any;
  pickup_long_name: any = "";
  pickup_short_name: any = "";
  dropAutoComplete: any;
  drop_long_name: any = "";
  drop_short_name: any = "";
  completeDropAddress: any;
  completePickUpAddress: any;
  @ViewChild("pickUpLocationSearchField")
  pickUpLocation: ElementRef | any;
  @ViewChild("dropLocationSearchField")
  dropLocation!: ElementRef | any;
  pickup_postal_code: any;
  dropoff_postal_code: any;
  minDate = new Date();
  driverList: any;
  token: any;
  driverTax: any;
  calculatedTax: any = "";
  locationError: boolean = false;
  locationsMatch: boolean = false;
  showCloseIconPick = false;
  showCloseIconDrop = false;

  constructor(
    private matDialogRef: MatDialogRef<AddDriverRouteComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private formBuilder: FormBuilder,
    private service: AdminService,
    private snackBar: MatSnackBar,
    private router: Router
  ) {
    this.driverList = data;
    this.driverTax = data.tax_details.filter(
      (value: any, index: any, self: any) =>
        index ===
        self.findIndex(
          (t: any) =>
            t.tax_name === value.tax_name &&
            t.tax_deduction === value.tax_deduction
        )
    );
  }

  ngOnInit(): void {
    this.token = localStorage.getItem("adminToken");
    this.calculateAndFormatTax();
    this.coordinatesForm = this.formBuilder.group({
      from_complete_address: new FormControl(
        null,
        Validators.compose([Validators.required])
      ),
      to_complete_address: new FormControl(
        null,
        Validators.compose([Validators.required])
      ),
      pickup_date: [""],
      price: new FormControl(null, Validators.compose([Validators.required])),
      truck_number: [""],
    });
    this.coordinatesForm.patchValue({
      from_complete_address:
        (this.driverList.fromLocation.from_area_name ?? "") +
        ", " +
        (this.driverList.fromLocation.from_city_name ?? "") +
        (this.driverList.fromLocation.from_pincode
          ? ", " + this.driverList.fromLocation.from_pincode
          : ""),

      to_complete_address:
        (this.driverList.toLocation.to_area_name ?? "") +
        ", " +
        (this.driverList.toLocation.to_city_name ?? "") +
        (this.driverList.toLocation.to_pincode
          ? ", " + this.driverList.toLocation.to_pincode
          : ""),

      pickup_date: this.driverList.createdAt,
      // price: this.driverList.route_fare,
      price:
        this.driverList?.bidDetails[0]?.trip_status === "pending" ||
        this.driverList?.bidDetails[0]?.trip_status === "trip_not_booked"
          ? "0.00"
          : this.driverList.workorderOtherDetails?.loading_point ??
            this.driverList.price ??
            "0.00",

      truck_number: this.driverList.truck_details[0]?.truck_number,
    });
  }

  calculateAndFormatTax(): void {
    if (this.data.tax_details && this.data.tax_details[0]) {
      const actualPrice = this.data.route_fare;
      const taxDeduction = this.data.tax_details[0].tax_deduction;
      const tax = (actualPrice * taxDeduction) / 100;
      this.calculatedTax = this.formatNumber(tax);
    }
  }

  getTotalFare(): number {
    let baseFare =
      // this.driverList.workorderOtherDetails?.loading_point ??
      // this.driverList.price ??
      // 0;

      this.driverList?.bidDetails[0]?.trip_status === "pending" ||
      this.driverList?.bidDetails[0]?.trip_status === "trip_not_booked"
        ? "0.00"
        : this.driverList.workorderOtherDetails?.loading_point ??
          this.driverList.price ??
          "0.00";
    // Calculate total tax deduction
    let totalTax = this.driverTax.reduce((acc: number, item: any) => {
      let taxAmount =
        item.tax_type === "percent"
          ? (baseFare * item.tax_deduction) / 100
          : item.tax_deduction;
      return acc + (taxAmount || 0);
    }, 0);

    return baseFare - totalTax; // Subtract tax from base fare
  }

  formatNumber(value: number): string {
    return Math.floor(value).toString();
  }
  ngAfterViewInit(): void {
    var options = {
      componentRestrictions: { country: "in" },
    };
    this.pickupAutoComplete = new google.maps.places.Autocomplete(
      this.pickUpLocation.nativeElement,
      options
    );
    this.dropAutoComplete = new google.maps.places.Autocomplete(
      this.dropLocation.nativeElement,
      options
    );
  }
  close() {
    this.matDialogRef.close();
  }

  onInputPickUpchange() {
    this.geoCodePickUp(this.coordinatesForm.value?.pickup);
    this.checkLocations();
  }
  geoCodePickUp(address: any) {
    google.maps.event.addListener(
      this.pickupAutoComplete,
      "place_changed",
      () => {
        const place = this.pickupAutoComplete.getPlace();
        const geoCoder = new google.maps.Geocoder();
        geoCoder.geocode(
          {
            address: place.formatted_address,
          },
          (results: any, status) => {
            if (status == google.maps.GeocoderStatus.OK) {
              this.pickupLat = results[0].geometry.location.lat();
              this.pickupLong = results[0].geometry.location.lng();
              const latlong = new google.maps.LatLng(
                this.pickupLat,
                this.pickupLong
              );
              geoCoder.geocode({ location: latlong }, (result: any, status) => {
                this.completePickUpAddress = result[0];
                this.pickup_short_name = "";
                this.pickup_long_name = "";
                for (
                  let i = 0;
                  i < this.completePickUpAddress.address_components.length;
                  i++
                ) {
                  if (
                    this.completePickUpAddress.address_components[i].types[0] ==
                      "locality" &&
                    this.completePickUpAddress.address_components[i].types[1] ==
                      "political"
                  ) {
                    this.pickup_short_name =
                      this.completePickUpAddress.address_components[
                        i
                      ].long_name;
                  }
                  if (
                    this.completePickUpAddress.address_components[i].types[0] ==
                      "political" &&
                    this.completePickUpAddress.address_components[i].types[1] ==
                      "sublocality" &&
                    this.completePickUpAddress.address_components[i].types[2] ==
                      "sublocality_level_1"
                  ) {
                    this.pickup_long_name =
                      this.completePickUpAddress.address_components[
                        i
                      ].long_name;
                  }
                  if (
                    this.completePickUpAddress.address_components[i].types[0] ==
                    "postal_code"
                  ) {
                    this.pickup_postal_code = Number(
                      this.completePickUpAddress.address_components[i].long_name
                    );
                  }
                }
              });
            }
          }
        );
      }
    );
  }
  onDropChange() {
    this.geoCodeDrop(this.coordinatesForm.value.drop);
    this.checkLocations();
  }
  checkLocations() {
    const pickup = this.coordinatesForm.value.from_complete_address;
    const drop = this.coordinatesForm.value.to_complete_address;
    if (pickup && drop && pickup === drop) {
      this.snackBar.open(
        "Pickup and Drop Off locations cannot be the same",
        "Fail",
        { duration: 5000 }
      );
    }
    return;
  }

  geoCodeDrop(address: any) {
    google.maps.event.addListener(
      this.dropAutoComplete,
      "place_changed",
      () => {
        const dropPlace = this.dropAutoComplete.getPlace();
        const geoCoder = new google.maps.Geocoder();
        geoCoder.geocode(
          {
            address: dropPlace.formatted_address,
          },
          (results: any, status) => {
            if (status == google.maps.GeocoderStatus.OK) {
              this.dropLat = results[0].geometry.location.lat();
              this.dropLong = results[0].geometry.location.lng();
              const latlong = new google.maps.LatLng(
                this.dropLat,
                this.dropLong
              );
              geoCoder.geocode({ location: latlong }, (result: any, status) => {
                this.completeDropAddress = result[0];
                this.drop_short_name = "";
                this.drop_short_name = "";
                for (
                  let i = 0;
                  i < this.completeDropAddress.address_components.length;
                  i++
                ) {
                  if (
                    this.completeDropAddress.address_components[i].types[0] ==
                      "locality" &&
                    this.completeDropAddress.address_components[i].types[1] ==
                      "political"
                  ) {
                    this.drop_short_name =
                      this.completeDropAddress.address_components[i].long_name;
                  }
                  if (
                    this.completeDropAddress.address_components[i].types[0] ==
                      "political" &&
                    this.completeDropAddress.address_components[i].types[1] ==
                      "sublocality" &&
                    this.completeDropAddress.address_components[i].types[2] ==
                      "sublocality_level_1"
                  ) {
                    this.drop_long_name =
                      this.completeDropAddress.address_components[i].long_name;
                  }
                  if (
                    this.completeDropAddress.address_components[i].types[0] ==
                    "postal_code"
                  ) {
                    this.dropoff_postal_code = Number(
                      this.completeDropAddress.address_components[i].long_name
                    );
                  }
                }
              });
            }
          }
        );
      }
    );
  }

  updateRoute() {
    const pickups = this.coordinatesForm.get("from_complete_address")?.value;
    const dropup = this.coordinatesForm.get("to_complete_address")?.value;
    if (pickups && dropup && pickups === dropup) {
      this.snackBar.open(
        "Pick-up and Drop-off locations should not be the same",
        "Fail",
        { duration: 5000 }
      );
      return;
    }
    if (this.coordinatesForm.invalid) {
      this.snackBar.open("Plesae fill all the mandatory fileds", "Fail", {
        duration: 5000,
      });
      return;
    }
    const Object = {
      fromLocation: {
        from_area_name:
          this.pickup_long_name || this.driverList.fromLocation.from_area_name,
        from_city_name:
          this.pickup_short_name || this.driverList.fromLocation.from_city_name,
        from_pincode:
          parseInt(this.pickup_postal_code || this.driverList.fromLocation.from_pincode || 0, 10) || 0,
        from_lat: this.pickupLat ? (Math.round(this.pickupLat * 10000) / 10000).toString() : this.driverList.fromLocation.from_lat,
        from_long: this.pickupLong ? (Math.round(this.pickupLong * 10000) / 10000).toString() : this.driverList.fromLocation.from_long,
      },
      toLocation: {
        to_area_name:
          this.drop_long_name || this.driverList.toLocation.to_area_name,
        to_city_name:
          this.drop_short_name || this.driverList.toLocation.to_city_name,
        to_pincode:
          parseInt(this.dropoff_postal_code || this.driverList.toLocation.to_pincode || 0, 10) || 0,
        to_lat: this.dropLat ? (Math.round(this.dropLat * 10000) / 10000).toString() : this.driverList.toLocation.to_lat,
        to_long: this.dropLong ? (Math.round(this.dropLong * 10000) / 10000).toString() : this.driverList.toLocation.to_long,
      },
      date: new Date(new Date(this.coordinatesForm.value.pickup_date).setUTCHours(0, 0, 0, 0)).toISOString(),
      price: this.driverList.route_fare,
      route_fare: this.driverList.route_fare,
      total_fare: this.driverList.total_fare,
    };
    this.service
      .updateDriverRoutes(this.driverList._id, this.token, Object)
      .subscribe(
        (response: any) => {
          if (
            (response.status == 201 && response.status == 200) ||
            response.body.data
          ) {
            this.snackBar.open(response.message, "Success", {
              duration: 5000,
            });
            this.matDialogRef.close({ event: "Success" });
          }
        },
        (error) => {
          if (error.error.message === "jwt malformed") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
          }
          if (error.error.message === "jwt expired") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
          }
          if (error.error.message === "invalid signature") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
          }
          this.snackBar.open(error.error.message, "Fail", {
            duration: 5000,
          });
        }
      );
  }
  clearPickField() {
    this.coordinatesForm.controls["from_complete_address"].setValue("");
  }
  clearDropField() {
    this.coordinatesForm.controls["to_complete_address"].setValue("");
  }
}
